<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <h1 style="color: white; padding-top: 10px; padding-top: 170px;">Product Detail</h1>
        <p style="color: white; padding-top: 10px;">Home > Applications > HK</p>
    </div>
    <div class="container" style="padding-top: 90px;">
        <div class="row">
            <div class="col-xl-6 col-md-6 col-sm-12" >
                <h3>{{ $t('app3') }}</h3>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('hkP1') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('hkP2') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('hkP3') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('hkP4') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('hkP5') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('hkP6') }}
                </p>
                
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12" style="text-align: center; margin-bottom: 90px;">
                <b-img src="@/assets/APP/app3.jpg" fluid alt="Responsive image"></b-img>
            </div>
        </div>
    </div>
</div> 
</template>

<script>

export default {
  name: 'HK',
  data(){
      return{
       slide: 0,
        }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}



</style>
